module.exports = __webpack_public_path__ + "static/media/custom-08.45877fb0.jpg";